<template>
  <g fill="none" fill-rule="evenodd" aria-hidden="true">
    <circle :fill="backgroundColor" cx="7" cy="7"
            r="7"
    />
    <path :fill="color"
          d="M7.684 7L10 9.316 9.316 10 7 7.684 4.684 10 4 9.316 6.316 7 4 4.684 4.684 4 7 6.316 9.316 4l.684.684z"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#869094'
    },
    backgroundColor: {
      type: String,
      default: '#D7E0E5'
    }
  }
}
</script>
